<template>
  <div>
    <v-tabs grow v-model="currentView">
      <v-tabs-slider color="secondary"></v-tabs-slider>
      <v-tab :key="formView">
        <div class="beez-bold  text-capitalize">Form View</div>
      </v-tab>
      <v-tab :key="jsonView">
        <div class="beez-bold  text-capitalize">Json View</div>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentView">
      <v-tab-item :key="formView">
        <div v-if="checkIfArray(input)">
          <display-variable-schema :variable-schema="input" />
        </div>
        <div v-else-if="checkIfObject(input)">
          <display-input-variable-schema :variable-schema="input" />
        </div>
        <div v-else>
          <v-alert
            :value="true"
            color="warning"
            icon="info"
            :outline="$vuetify.dark"
            style="border-radius: 5px"
          >
            No form elements found!
          </v-alert>
        </div>
      </v-tab-item>
      <v-tab-item :key="jsonView">
        <v-jsoneditor
          class="mb-4"
          v-model="input"
          :options="jsonOptions"
          height="400px"
          key="jsonEditor"
        >
        </v-jsoneditor>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import VJsoneditor from 'v-jsoneditor/src/index'
import DisplayVariableSchema from '@/components/execution/DisplayVariableSchema.vue'
import DisplayInputVariableSchema from '@/components/execution/DisplayInputVariableSchema.vue'
import _ from 'lodash'

export default {
  name: 'displayExecutionSchema',
  components: {
    VJsoneditor,
    DisplayVariableSchema,
    DisplayInputVariableSchema
  },
  props: {
    input: {}
  },
  data: () => ({
    jsonOptions: { mode: 'code' },
    jsonView: 1,
    formView: 0,
    currentView: 0
  }),
  methods: {
    checkIfArray(input) {
      return _.isArray(input)
    },
    checkIfObject(input) {
      return _.isObject(input)
    }
  }
}
</script>
